import { render, staticRenderFns } from "./userConsume.vue?vue&type=template&id=3e38cc4b&scoped=true&"
import script from "./userConsume.vue?vue&type=script&lang=js&"
export * from "./userConsume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e38cc4b",
  null
  
)

export default component.exports